var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 16.5001C5.15245 16.5001 3.57967 15.8579 2.28134 14.5734C0.982452 13.2884 0.333008 11.7362 0.333008 9.91675C0.333008 9.00008 0.506619 8.15286 0.853841 7.37508C1.20106 6.5973 1.68023 5.90286 2.29134 5.29175L6.99967 0.666748L11.708 5.29175C12.3191 5.90286 12.7983 6.5973 13.1455 7.37508C13.4927 8.15286 13.6663 9.00008 13.6663 9.91675C13.6663 11.7362 13.0172 13.2884 11.7188 14.5734C10.42 15.8579 8.8469 16.5001 6.99967 16.5001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityHigh);
export default __webpack_public_path__ + "static/media/humidityHigh.61d9b969ea447335fa96a4d0adedb8d9.svg";
export { ForwardRef as ReactComponent };